export default "__VITE_ASSET__CC4U_Woz__";